<template lang="pug">
	.loader-container
		VueSpinner
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import VueSpinner from '@ui-common/vue-spinner';

export default defineComponent({
	components: {
		VueSpinner
	},
	setup() {}
});
</script>

<style src="@ui-common/vue-spinner/dist/vue-spinner.css"></style>
<style lang="scss" scoped>
.loader-container {
	min-height: 120px;
}
</style>
